import React, { useState } from "react";
import clsx from "clsx";
import { ChevronDown } from "lucide-react";

const Dropdown = ({
  filter,
  selectedOption,
  handleChange,
  index,
  defaultValue = "",
  className,
  largerDropdown = false,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const handleOptionClick = (option) => {
    handleChange({ target: { value: option.value } }, filter);
    setIsOpen(false);
  };

  return (
    <>
      {isOpen && (
        <div
          onClick={() => setIsOpen(false)}
          className="fixed backdrop-filter top-0 left-0 w-full h-full bg-[#000000] bg-opacity-15 "
        />
      )}
      <div className="relative">
        {filter.title && (
          <span className="flex dark:text-white text-sm mb-1 text-gray-500 font-semibold">
            {filter.title}
          </span>
        )}
        <div
          data-testid={`dropdown`}
          className={clsx(
            "flex dark:bg-gray-700 dark:border-gray-600 items-center justify-between w-full py-[10px] px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-primary-500 focus:border-primary-500 cursor-pointer",
            largerDropdown ? "max-w-xl" : "max-w-md",
            className
          )}
          onClick={toggleDropdown}
        >
          <span className="truncate">
            {selectedOption?.displayName || defaultValue}
          </span>
          <span
            className={clsx(
              "transform transition-transform duration-200",
              isOpen ? "rotate-180" : "rotate-0"
            )}
          >
            <ChevronDown size={18} />
          </span>
        </div>
        {isOpen && (
          <div
            className={clsx(
              "absolute max-h-80 overflow-y-auto w-full dark:bg-gray-700 dark:border-gray-600 bg-white border border-gray-300 rounded-md shadow-lg z-10",
              largerDropdown ? "max-w-xl" : "max-w-lg"
            )}
          >
            {filter.values.map((option, index) => (
              <div
                data-testid={`dropdown-option-${index}`}
                key={option.value}
                className={clsx(
                  "py-2 px-3 cursor-pointer text-sm dark:bg-gray-700 dark:border-gray-600 hover:bg-gray-100 border-b border-gray-300",
                  option.className,
                  "line-clamp-3"
                )}
                onClick={() => handleOptionClick(option)}
              >
                {option.displayName}
              </div>
            ))}
          </div>
        )}
      </div>
    </>
  );
};

export default Dropdown;
